const $$splitComponentImporter = () => import('/src/src/routes/auto-login.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
export const Route = createFileRoute("/auto-login")({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});